import React from 'react';
import { Flex } from '@chakra-ui/react';
import { PropertySchema } from '../property/Property.types';
import PropertyDropdown from '../dropdowns/PropertyDropdown';

export default function TableHeader({
    id,
    properties,
    ...props
  }: {
    id: string;
    properties: PropertySchema[];
    onPropertyDelete: (index: number) => void;
    onPropertyDuplicate: (value: PropertySchema) => void;
    onPropertyUpdate: (value: PropertySchema, index: number) => void;
  }) {
    const property = properties?.find(({ name }) => name === id) as PropertySchema;
    
    const propertyIndex = properties?.findIndex(({ name }) => name === id);
    
    const [isDropDownOpen, setIsDropDownOpen] = React.useState(false)
    const openDropdown = () => setIsDropDownOpen(!isDropDownOpen)
    const closeDropdown = () => setIsDropDownOpen(false)
    
    return (
      <PropertyDropdown
        property={property}
        isOpen={isDropDownOpen}
        onClose={closeDropdown}
        onDelete={() => props.onPropertyDelete(propertyIndex)}
        onDuplicate={() => props.onPropertyDuplicate(property)}
        onChange={property => props.onPropertyUpdate(property, propertyIndex)}
      >
        <Flex className='pointer' alignItems={'center'} onClick={openDropdown}> 
          <span style={{ marginRight: '0.3rem', color: '#637381' }}>{property && property.icon}</span>
          <span style={{ color: '#637381' }}>{property && property.name}</span>
        </Flex>
      </PropertyDropdown>
    );
  }